import React, {Component} from 'react';
import {message} from 'antd';
import {connect} from 'react-redux';

import localDb from '@util/localDb';
import {queryBudgetSetInfo} from '@api/finance/budget';
import {getExpendType} from '@store/modules/finance/expend_type';
import {getCompanyList} from '@store/modules/company_list';

import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getSetInfo();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  getSetInfo = () => {
    queryBudgetSetInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return <span />;
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(PageInfo);



// WEBPACK FOOTER //
// ./src/components/finance/budget/set/PageInfo.js